import axios from "axios/index";
import api from "../../config/_api";
import {SYSTEM_MANUFACTURER_UPDATED} from "../actions/system_manufacturer";

const state = {
    system_manufacturer: []
};
const actions = {
    getManufacturers: ({commit, rootGetters}) => {
        axios({url: api.url + 'manufacturer', method: 'GET' })
            .then(resp => {
                commit('SYSTEM_MANUFACTURER_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
};
const mutations = {
    [SYSTEM_MANUFACTURER_UPDATED]: (state, system_manufacturer) => {
        system_manufacturer.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        state.system_manufacturer = system_manufacturer;
    },
};
const getters = {
    system_manufacturer : state => state.system_manufacturer,
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
